export default {
    getActivity: { url: '/api/activity/', method: 'get' },
    getAllActivitiesByOrg: { url: '/api/activity/allOrgActivities/', method: 'get' },
    updateActivity: { url: '/api/activity/', method: 'put' }, // caller: `${url}${activityId}/roadmap/${roadmapId}`
    deleteActivity: { url: '/api/activity/', method: 'delete' }, // caller: `${url}${activityId}/roadmap/${roadmapId}`
    unimportActivity: { url: '/api/activity/', method: 'delete' }, // caller: `${url}${activityId}/roadmap/${roadmapId}/unimport`
    importActivities: { url: '/api/activities/roadmap/', method: 'post' }, // caller: `${url}${roadmapId}/import`
    importExternalActivity: { url: '/api/activity/roadmap/', method: 'post' }, // caller: `${url}${roadmapId}/external-import`
    linkActivityToExternalSource: { url: '/api/activity/', method: 'put' }, // caller: `${url}${activityId}/roadmap/${roadmapId}/link-external-source`
    getActivitiesForTable: { url: '/api/activities/', method: 'get' },
    getLinkedActivities: { url: '/api/activities/list/', method: 'post' },
    createActivity: { url: '/api/activity/', method: 'post' },
    checkStudyNumber: { url: '/api/activity/check-study-number', method: 'get' },
    addPrimaryEvidenceToActivity: { url: '/api/activity/addPrimaryEvidence/', method: 'put' },
    removePrimaryEvidenceToActivity: { url: '/api/activity/removePrimaryEvidence/', method: 'put' },
    reorderActivities: { url: '/api/activity/reorder', method: 'post' },

    getStrategy: { url: '/api/strategy/', method: 'get' },
    createStrategy: { url: '/api/strategy/', method: 'post' },
    createSnapshot: { url: '/api/snapshot/', method: 'post' },
    dismissSnapshotJob: { url: '/api/snapshot-job/', method: 'delete' },
    updateStrategy: { url: '/api/strategy/', method: 'put' },

    // :id/removeFile/:s3Name/:fileType
    removeStrategyFile: { url: '/api/strategy/', method: 'delete' },

    getValueMessage: { url: '/api/value-message/', method: 'get' },
    getValueMessagesForTable: { url: '/api/value-messages/', method: 'get' },
    getValueMessagesByOrganizationId: { url: '/api/value-messages/org/', method: 'get' },
    updateValueMessage: { url: '/api/value-message/', method: 'put' },
    deleteValueMessage: { url: '/api/value-message/', method: 'delete' },
    getLinkedVMs: { url: '/api/value-messages/list/', method: 'post' },
    createValueMessage: { url: '/api/value-message/', method: 'post' },
    reorderVMs: { url: '/api/value-message/reorder/', method: 'post' },
    addPrimaryEvidence: { url: '/api/value-message/addPrimaryEvidence/', method: 'put' },
    removePrimaryEvidence: { url: '/api/value-message/removePrimaryEvidence/', method: 'put' },
    removeCountryFromVM: { url: '/api/value-message/removeCountry/', method: 'put' },

    createDraft: { url: '/api/draft', method: 'post' },
    getDraftsByStrategyId: { url: '/api/drafts/', method: 'get' },
    updateDraft: { url: '/api/draft/', method: 'put' },
    deleteDraft: { url: '/api/draft/', method: 'delete' },
    downloadDraftFile: { url: '/api/file/draft/', method: 'get' },
    generateDraftKES: { url: '/api/draft/', method: 'post' },
    resetDraftToDraft: { url: '/api/draft/', method: 'post' },
    getKESByDraftId: { url: '/api/key-evidence-statement/draft/', method: 'get' },
    updateKES: { url: '/api/key-evidence-statement/', method: 'put' },
    deleteKES: { url: '/api/key-evidence-statement/', method: 'delete' },
    searchPubMedIds: { url: '/api/external-evidence/search-ids', method: 'get' },
    fetchPubMedArticles: { url: '/api/external-evidence/fetch-articles', method: 'post' },
    checkDuplicates: { url: '/api/external-evidence/check-duplicates', method: 'post' },
    importExternalEvidence: { url: '/api/external-evidence/import', method: 'post' },
    searchExternalActivities: { url: '/api/external-activities/search', method: 'post' },
    getExternalActivityFacets: { url: '/api/external-activities/facets', method: 'get' },
    getSyncRuns: { url: '/api/sync/runs/', method: 'get' }, // caller: `${url}${organizationId}`
    getSyncRunEntries: { url: '/api/sync/runs/', method: 'get' }, // caller: `${url}${organizationId}/${runId}/entries`
    getFieldMappings: { url: '/api/field-mappings/', method: 'get' }, // caller: `${url}${organizationId}`
    createFieldMapping: { url: '/api/field-mappings/', method: 'post' }, // caller: `${url}${organizationId}`
    updateFieldMapping: { url: '/api/field-mappings/', method: 'put' }, // caller: `${url}${organizationId}/${mappingId}`
    deleteFieldMapping: { url: '/api/field-mappings/', method: 'delete' }, // caller: `${url}${organizationId}/${mappingId}`

    deleteEvidence: { url: '/api/evidence/', method: 'delete' },
    updateEvidence: { url: '/api/evidence/', method: 'put' },
    getEvidence: { url: '/api/evidence/', method: 'get' },
    getEvidenceById: { url: '/api/evidence/:id', method: 'get' },
    getEvidenceForTable: { url: '/api/evidences/', method: 'get' },
    getLinkedEvidence: { url: '/api/evidence/list/', method: 'post' },
    createEvidence: { url: '/api/evidence/', method: 'post' },
    downloadEvidenceFile: { url: '/api/file/evidence/', method: 'get' },
    reorderEvidences: { url: '/api/evidence/reorder', method: 'post' },

    getNumberOfPillarsViaLinkedVMs: { url: '/api/evidence/pillars/', method: 'post' },

    deleteGapAnalysis: { url: '/api/gap-analysis/', method: 'delete' },
    updateGapAnalysis: { url: '/api/gap-analysis/', method: 'put' },
    getGapAnalysis: { url: '/api/gap-analysis/strategy/', method: 'get' },
    addMarketAccessGoal: { url: '/api/gap-analysis/goal/', method: 'post' },
    deleteMarketAccessGoal: { url: '/api/gap-analysis/goal/', method: 'delete' },
    updateGapAssessmentValue: { url: '/api/gap-analysis/assessment/', method: 'put' },
    updateReimbursableFileValue: { url: '/api/gap-analysis/reimbursable-file/', method: 'put' },

    getSIForTable: { url: '/api/strategic-imperatives/', method: 'get' },
    createStrategicImperative: { url: '/api/strategic-imperative', method: 'post' },
    getStrategicImperative: { url: '/api/strategic-imperative/', method: 'get' },
    deleteStrategicImperative: { url: '/api/strategic-imperative/', method: 'delete' },
    updateStrategicImperative: { url: '/api/strategic-imperative/', method: 'put' },
    reorderStrategicImperatives: { url: '/api/strategic-imperatives/reorder', method: 'post' },

    createDeliverable: { url: '/api/deliverable/', method: 'post' },
    deleteDeliverableById: { url: '/api/deliverable/', method: 'delete' },
    updateDeliverableById: { url: '/api/deliverable/', method: 'put' },
    getDeliverableById: { url: '/api/deliverable/', method: 'get' },
    getDeliverableList: { url: '/api/deliverables/list/', method: 'post' },
    updateDeliverablesList: { url: '/api/deliverables/updateManyList/', method: 'post' },
    getDeliverablesByOrganization: { url: '/api/deliverables/', method: 'get' },

    // need to add /strategies to the end
    getStrategiesByOrganizationId: { url: '/api/organization/', method: 'get' },
    getSettingsByOrganizationId: { url: '/api/settings/organization/', method: 'get' },
    saveSettings: { url: '/api/settings/', method: 'put' },

    getOrganizationById: { url: '/api/organization/', method: 'get' },
    getFreeTrialStatus: { url: '/api/organization/trial/', method: 'get' },

    getRequiredFields: { url: '/api/required-fields/', method: 'get' },

    getUserAuth0: { url: '/api/users/', method: 'get' },
    changeUserColorMode: { url: '/api/user/colorMode', method: 'put' },
    updateUser: { url: '/api/user', method: 'put' },

    // Append orgId to this call
    downloadAnyFile: { url: '/api/file/any/', method: 'get' },

    getTracelinksForTable: { url: '/api/tracelink', method: 'get' },
    createTracelink: { url: '/api/tracelink', method: 'post' },

    createEvidenceGap: { url: '/api/evidence-gap', method: 'post' },
    deleteEvidenceGap: { url: '/api/evidence-gap/', method: 'delete' },
    updateEvidenceGap: { url: '/api/evidence-gap/', method: 'put' },
    getEvidenceGapsByStrategyId: { url: '/api/evidence-gaps/', method: 'get' },
    getEvidenceGapsByValueMessageId: { url: '/api/evidence-gaps/vm/', method: 'get' },
    reorderEvidenceGaps: { url: '/api/evidence-gaps', method: 'put' },

    submitFeedback: { url: '/api/feedback', method: 'post' },

    getTableComments: { url: '/api/comment/table/', method: 'get' },
    getCommentsDashboard: { url: '/api/comment/dashboard/', method: 'get' },
    getDataComments: { url: '/api/comment/data/', method: 'get' },
    postDataComment: { url: '/api/comment/', method: 'post' },
    updateDataComment: { url: '/api/comment/', method: 'put' },
    deleteDataComment: { url: '/api/comment/', method: 'delete' },

    getValueNarratives: { url: '/api/narrative/roadmap/', method: 'get' },
    createValueNarrative: { url: '/api/narrative/', method: 'post' },
    updateValueNarrative: { url: '/api/narrative/', method: 'put' },
    lockValueNarrative: { url: '/api/narrative/lock/', method: 'put' },
    transferValueNarrative: { url: '/api/narrative/transfer/', method: 'put' },
    archiveValueNarrative: { url: '/api/narrative/archive/', method: 'put' },
    deleteValueNarrative: { url: '/api/narrative/delete/', method: 'delete' },
    reorderValueNarratives: { url: '/api/narrative/reorder/', method: 'post' },

    generatePicoReport: { url: '/api/pico/generate', method: 'post' },
    getPicoReport: { url: '/api/pico/report/', method: 'get' },
    getPicoReports: { url: '/api/pico/history/', method: 'get' },
    getPicoDiseaseMatches: { url: '/api/pico/disease/', method: 'get' },
    getPicoDrugMatches: { url: '/api/pico/drug/', method: 'get' },
    getNarrativeCategories: { url: '/api/narrative-category/org/', method: 'get' },
    getNarrativeCategoriesByStrategy: { url: '/api/narrative-category/org/', method: 'get' },

    getValueCompendiumHome: { url: '/api/value-compendium/home/', method: 'get' },
    getValueCompendiumValueMessage: { url: '/api/value-compendium/value-message/', method: 'get' },
    getValueCompendiumValueNarratives: { url: '/api/value-compendium/narratives/', method: 'get' },
    getValueCompendiumReferences: { url: '/api/value-compendium/references/', method: 'get' },

    getActivityLinkableItems: { url: '/api/activity/linkable-items/', method: 'get' },
    getEvidenceLinkableItems: { url: '/api/evidence/linkable-items/', method: 'get' },
    getValueMessageLinkableItems: { url: '/api/value-message/linkable-items/', method: 'get' },
    getStrategicImperativeLinkableItems: { url: '/api/strategic-imperative/linkable-items/', method: 'get' },
    getTppCellLinkableItems: { url: '/api/tpp/cells/linkable-items/', method: 'get' },

    getActivityLinkedItems: { url: '/api/activity/linked-items/', method: 'get' },
    getEvidenceLinkedItems: { url: '/api/evidence/linked-items/', method: 'get' },
    getValueMessageLinkedItems: { url: '/api/value-message/linked-items/', method: 'get' },
    getStrategicImperativeLinkedItems: { url: '/api/strategic-imperative/linked-items/', method: 'get' },
    getTppCellLinkedItems: { url: '/api/tpp/cells/linked-items/', method: 'get' },

    updateActivityLinkedItems: { url: '/api/activity/linked-items/', method: 'put' },
    updateEvidenceLinkedItems: { url: '/api/evidence/linked-items/', method: 'put' },
    updateValueMessageLinkedItems: { url: '/api/value-message/linked-items/', method: 'put' },
    transferValueMessage: { url: '/api/value-message/transfer/', method: 'put' },
    updateStrategicImperativeLinkedItems: { url: '/api/strategic-imperative/linked-items/', method: 'put' },
    updateTppCellLinkedItems: { url: '/api/tpp/cells/linked-items/', method: 'put' },

    getValueMessageExpandingTableData: { url: '/api/value-messages/table-data/', method: 'get' },

    handleEvidenceGaps: { url: '/api/evidence-gap/modify', method: 'post' },

    handleKeyEvidenceStatements: { url: '/api/key-evidence-statement/modify', method: 'post' },
    getKeyEvidenceStatements: { url: '/api/key-evidence-statement/', method: 'get' },
    getKeyEvidenceStatementsByStrategy: { url: '/api/key-evidence-statement/strategy/', method: 'get' },

    getChatQueryStatus: { url: '/api/chat/status/:taskId', method: 'get' },
    createChatThread: { url: '/api/chat/threads', method: 'post' },
    getChatThread: { url: '/api/chat/threads/:threadId', method: 'get' },
    addChatThreadMessage: { url: '/api/chat/threads/:threadId/messages', method: 'post' },
    deleteChatThread: { url: '/api/chat/threads/:threadId', method: 'delete' },
    createChatTopic: { url: '/api/chat/topics', method: 'post' },
    getChatTopic: { url: '/api/chat/topics/:topicId', method: 'get' },
    deleteChatTopic: { url: '/api/chat/topics/:topicId', method: 'delete' },
    getChatHistory: { url: '/api/chat/history', method: 'get' },
    resetChatHistory: { url: '/api/chat/history', method: 'delete' },
    processEvidenceForMaia: { url: '/api/chatbot/process-evidence', method: 'post' },
    getEvidenceMaiaStatus: { url: '/api/chatbot/evidence-status/', method: 'get' },
    resetMaiaStatus: { url: '/api/chatbot/reset-evidence-maia-status', method: 'POST' },
    deleteVectorRecords: { url: '/api/chatbot/delete-vector-records', method: 'POST' },
    getEvidencePresignedUrl: { url: '/api/evidence/presigned-url', method: 'get' },

    logEvent: { url: '/api/event/log', method: 'post' },

    authenticateSession: { url: '/api/auth/session', method: 'post' },

    getImpactMetrics: { url: '/api/metrics/impact/', method: 'get' },
    getDeliverables: { url: '/api/metrics/deliverables-type/', method: 'get' },
    getActivityByFunction: { url: '/api/metrics/activity-function/', method: 'get' },
    getValueMessageSupport: { url: '/api/metrics/value-message-support/', method: 'get' },
    getTppImpactMetrics: { url: '/api/metrics/tpp-impact/', method: 'get' },
    getTppElementSupport: { url: '/api/metrics/tpp-element-support/', method: 'get' },

    // --------------------
    // Joe's Temp FE endpoints, they work but someone prolly oughta organize em at some point
    // --------------------

    getTPPCellsByTPPId: { url: '/api/tpps/cells', method: 'get' }, // caller: `${url}/${tppId}`
    createTPPCell: { url: '/api/tpps/cells/create', method: 'post' },
    cloneTPPCell: { url: '/api/tpps/cells/:cellId/clone', method: 'post' },
    decloneTPPCell: { url: '/api/tpps/cells/:cellId/declone', method: 'put' },
    lockTPPCell: { url: '/api/tpps/cells', method: 'put' }, // caller: `${url}/${cellId}/lock`
    toggleHighlightTPPCell: { url: '/api/tpps/cells', method: 'put' }, // caller: `${url}/${cellId}/highlight`
    reorderTPPCell: { url: '/api/tpps/cells', method: 'put' }, // caller: `${url}/${cellId}/reorder`
    deleteTPPCell: { url: '/api/tpps/cells', method: 'delete' }, // caller: `${url}/${cellId}/delete`
    updateTPPCellContent: { url: '/api/tpps/cells', method: 'put' }, // caller: `${url}/${cellId}/update`

    getAllOrganizations: { url: '/api/organizations/all', method: 'get' },

    // Admin endpoints
    adminGetOrganizations: { url: '/api/admin/organizations', method: 'get' },
    adminGetOrganizationDetail: { url: '/api/admin/organizations/', method: 'get' },
    adminUpdateOrganizationFlags: { url: '/api/admin/organizations/', method: 'patch' },
    adminGetUsersByOrg: { url: '/api/admin/organizations/', method: 'get' },
    adminUpdateUserRoles: { url: '/api/admin/users/', method: 'patch' },
    adminGetRoadmapsByOrg: { url: '/api/admin/organizations/', method: 'get' },
    adminGetRoadmapAllowedUsers: { url: '/api/admin/roadmaps/', method: 'get' },
    adminUpdateRoadmapAllowedUsers: { url: '/api/admin/roadmaps/', method: 'patch' },
    adminGetAuditLogs: { url: '/api/admin/audit-logs', method: 'get' },

    // --------------------
    // TPP (Columns, Sections, Rows, Slots)
    // --------------------
    getTPPIdByRoadmap: { url: '/api/tpps/roadmap', method: 'get' }, // caller: `${url}/${roadmapId}`
    getTPP: { url: '/api/tpps', method: 'get' }, // caller: `${url}/${tppId}`
    getTPPColumns: { url: '/api/tpps/columns', method: 'get' }, // caller: `${url}/${tppId}`
    getTPPSections: { url: '/api/tpps/sections', method: 'get' }, // caller: `${url}/${tppId}`
    getTPPRows: { url: '/api/tpps/rows', method: 'get' }, // caller: `${url}/${tppId}`
    getTPPSlots: { url: '/api/tpps/slots', method: 'get' }, // caller: `${url}/${tppId}`
    updateAssetAmbition: { url: '/api/tpps/:tppId/assetambition/update', method: 'put' },

    // Columns
    cloneTPPColumn: { url: '/api/tpps/columns/clone', method: 'post' },
    toggleLockTPPColumn: { url: '/api/tpps/columns', method: 'put' }, // caller: `${url}/${columnId}/lock`
    togglePinTPPColumn: { url: '/api/tpps/columns', method: 'put' }, // caller: `${url}/${columnId}/pin`
    archiveTPPColumn: { url: '/api/tpps/columns', method: 'put' }, // caller: `${url}/${columnId}/archive`
    reorderTPPColumns: { url: '/api/tpps', method: 'put' }, // caller: `${url}/${tppId}/column/reorder`
    updateTPPColumn: { url: '/api/tpps/columns/:columnId/update', method: 'put' },

    // Column Versions
    createTPPColumnVersion: { url: '/api/tpps/columns', method: 'post' }, // caller: `${columnId}/versions`
    getTPPColumnVersions: { url: '/api/tpps/columns', method: 'get' }, // caller: `${columnId}/versions`

    // Sections
    reorderTPPSections: { url: '/api/tpps', method: 'put' }, // caller: `${url}/${tppId}/section/reorder`
    createTPPSection: { url: '/api/tpps/sections/create', method: 'post' },
    updateTPPSectionTitle: { url: '/api/tpps/sections', method: 'put' }, // caller: `${url}/${sectionId}/title`
    deleteTPPSection: { url: '/api/tpps/sections', method: 'delete' }, // caller: `${url}/${sectionId}`

    // Rows
    reorderTPPRows: { url: '/api/tpps/sections', method: 'put' }, // caller: `${url}/${sectionId}/row/reorder`
    createTPPRow: { url: '/api/tpps/rows/create', method: 'post' },
    updateTPPRowTitle: { url: '/api/tpps/rows', method: 'put' }, // caller: `${url}/${rowId}/title`
    deleteTPPRow: { url: '/api/tpps/rows', method: 'delete' }, // caller: `${url}/${rowId}`

    // Slots
    createTPPSlot: { url: '/api/tpps/slots/create', method: 'post' },
    reorderTPPSlots: { url: '/api/tpps/rows', method: 'put' },
    updateTPPSlotContext: { url: '/api/tpps/slots', method: 'put' },
}
